// extracted by mini-css-extract-plugin
export default {"sideBarContainer":"sideBar_sideBarContainer__bctUK"};